import React from 'react';
import useTranslation from '../CustomHooks/useTranslation';
import { inputFieldContent } from './InputFieldContent';

interface InputLabelProps {
  labelName: string;
  id: string;
  required?: boolean;
  marginBottom? : string;
}

const InputLabel: React.FC<InputLabelProps> = ({ labelName, id, required, marginBottom }) => {
  const { translate } = useTranslation(inputFieldContent)
  return (
    <>
      <label htmlFor={id} id={id} title={translate(labelName)} className={`block more-lines w-fit text-large text-primary_text ${marginBottom ? marginBottom : 'mb-1'} `}>
      {translate(labelName)} {required && <span className="text-negative">*</span>}
      </label>
    </>
  );
};

export default InputLabel;
